import React from 'react';
import PropTypes from 'prop-types';

import { SearchHero } from 'components/landing/SearchHero';
import { Breadcrumbs } from 'components/core/Breadcrumbs';

import './StateSearchHero.scss';

export default function StateSearchHero({ location, stateUrl, stateNickname }) {
	return (
		<div className="state-search-hero">
			<Breadcrumbs
				location={location}
				stateUrl={stateUrl}
				tertiary
			/>
			<SearchHero
				className="state-page-hero"
				headline={`Welcome to ${location.fullState}`}
				subheading={`Your life in the ${stateNickname} begins`}
			/>
		</div>
	);
}

StateSearchHero.propTypes = {
	location: PropTypes.shape({
		state: PropTypes.string.isRequired,
		fullState: PropTypes.string.isRequired,
	}).isRequired,
	stateUrl: PropTypes.string.isRequired,
	stateNickname: PropTypes.string.isRequired,
};
